import React from 'react'
import CallDriver from 'App/Pages/Alerts/Orders/List/Order/CallDriver'
import SelectAgentMenu from './SelectAgentMenu'
import useTwilioDevice, {useMyCallingCapabilityToken} from 'App/hooks/useTwilioDevice'
import styles from './styles.css'

export default function ConversationHeader({vehicle, assignedAgent, assignConversation}) {
  const callingCapabilityToken = useMyCallingCapabilityToken()
  const {currentCallPhoneNumber, makeCall, stopCall} = useTwilioDevice(callingCapabilityToken)

  const orders = vehicle.activeOrders

  return (
    <div className={styles.container}>
      <div>
        <h2 className={styles.header}>
          #{vehicle.code} {vehicle.fullName}
        </h2>
        <span>{`Categoría ${vehicle.categoryId} - ${vehicle.completedOrdersCount} viajes`}</span>
      </div>
      <div className={styles.actions}>
        {assignConversation ? (
          <SelectAgentMenu value={assignedAgent} onChange={assignConversation} />
        ) : null}
        <CallDriver
          makeCall={makeCall}
          stopCall={stopCall}
          currentCallPhoneNumber={currentCallPhoneNumber}
          phone={vehicle.phone}
          tooltipPlace="bottom"
          order={orders ? orders[0] : null}
        />
      </div>
    </div>
  )
}
